import {authHeader} from "../util/auth-header";
import http from "../util/http-common";

export class VehicleConfigService {
    static async getVehicleMakes() {
        return http.get("/cfadminvehicleconfig/api/v1/mmy/makes", {headers: await authHeader()});
    }

    static async getVehicleModels(make: string, year: string) {
        return http.get(`/cfadminvehicleconfig/api/v1/mmy/models?make=${make}&year=${year}`, {headers: await authHeader()});
    }

    static async getVehicleYears() {
        return http.get("/cfadminvehicleconfig/api/v1/mmy/years", {headers: await authHeader()});
    }

    static async getAttributes(modelYearId: string) {
        return http.get(`/cfadminvehicleconfig/api/v1/attributes?modelYearId=${modelYearId}`, {headers: await authHeader()});
    }

    static async getAttributesAll() {
        return http.get(`/cfadminvehicleconfig/api/v1/attributes`, {headers: await authHeader()});
    }

    static async getVehicleAttributes(data: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/mmy`, data, {headers: await authHeader()});
    }

    static async getVehicleAttributeValues(data: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/attribute-values-query`, data, {headers: await authHeader()});
    }

    static async getVehicleConfigurations(data: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/generate-configuration-combination`, data, {headers: await authHeader()});
    }

    static async getVehicleConfigurationDetails(make: any, model: any, year: any) {
        return http.get(`/cfadminvehicleconfig/api/v1/vehicle?make=${make}&year=${year}&model=${model}`, {headers: await authHeader()});
    }

    static async getVehicleConfigurationsWithId(modelYearId: any) {
        return http.get(`/cfadminvehicleconfig/api/v1/vehicle/modelyear-query?modelYearId=${modelYearId}`, {headers: await authHeader()});
    }

    static async deleteModelYear(modelYearId: any) {
        return http.delete(`/cfadminvehicleconfig/api/v1/vehicle/modelyear/${modelYearId}`, {headers: await authHeader()});
    }

    static async deleteVehicle(vehicleId: any) {
        return http.delete(`/cfadminvehicleconfig/api/v1/vehicle/${vehicleId}`, {headers: await authHeader()});
    }

    static async deleteVehicleAttribute(attributeID: any, modelYearId: any) {
        return http.delete(`/cfadminvehicleconfig/api/v1/vehicle/attribute?attributeID=${attributeID}&modelYearID=${modelYearId}`, {headers: await authHeader()});
    }

    static async getVehicleAttributeCombinations(data: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/vehicle/generate-configuration-combination`, data, {headers: await authHeader()});
    }

    static async createVehicleConfigurations(data: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/vehicle/create-new-configuration`, data, {headers: await authHeader()});
    }

    static async getSystemSuggestedModels() {
        return http.get(`/cfadminvehicleconfig/api/v1/system-suggested-models`, {headers: await authHeader()});
    }

    static async getVinMappedAttributes() {
        return http.get(`/cfadminvehicleconfig/api/v1/attributes?vinMapped=true`, {headers: await authHeader()});
    }

    static async getSystemSuggestedConfigurations(data: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/system-suggested-configurations-query`, data, {headers: await authHeader()});
    }

    static async getSystemSuggestedVehicles() {
        return http.get(`/cfadminvehicleconfig/api/v1/suggested-vehicles`, {headers: await authHeader()});
    }

    static async discardVehicles(data: any) {
        return http.put(`/cfadminvehicleconfig/api/v1/suggested-vehicles/discard-vehicles`, data, {headers: await authHeader()});
    }

    static async getUnSupportedVehicles() {
        return http.get(`/cfadminvehicleconfig/api/v1/unsupported-vehicles`, {headers: await authHeader()});
    }

    static async supportVehicles(data: any) {
        return http.put(`/cfadminvehicleconfig/api/v1/unsupported-vehicles`, data, {headers: await authHeader()});
    }

    static async getScheduleMaintenanceDrivingConditions(request: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/vehicle-driving-conditions-query`, request, {headers: await authHeader()});
    }

    static async getScheduleMaintenanceVehicles(request: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/vehicle-configuration`, request, {headers: await authHeader()});
    }

    static async getScheduleMaintenanceIntervals(vehicleDrivingConditionId: any) {
        return http.get(`/cfadminvehicleconfig/api/v1/maintenance-schedules/${vehicleDrivingConditionId}`, {headers: await authHeader()});
    }

    static async getVehicleScheduleMaintenance(vehicleDrivingConditionId: any, scheduleCode: any, countryLanguageId: any) {
        return http.get(`/cfadminvehicleconfig/api/v1/maintenance-schedules/${vehicleDrivingConditionId}/${scheduleCode}?countryLanguageId=${countryLanguageId}`, {headers: await authHeader()});
    }

    static async getDecodeVin(vin: any) {
        return http.get(`/cfadminvehicleconfig/api/v1/vehicle-configuration/decode-vin-data?vin=${vin}`, {headers: await authHeader()});
    }

    static async decodeTestVin(request: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/vehicle-configuration/decode-test-client-data`, request, {headers: await authHeader()});
    }

    static async decodeTestVinWithNhtsa(request: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/vehicle-configuration/decode-test-client-data-nhtsa`, request, {headers: await authHeader()});
    }

    // New methods for getting, creating and updating attributes values used by CFAdminAttributes

    static async getVehicleAttributeValuesWithIds(data: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/attribute-values-query/by-attribute-ids`, data, {headers: await authHeader()});
    }

    static async createVehicleAttributeValue(data: any) {
        return http.post(`/cfadminvinadmin/api/v1/vehicle-attribute-values`, data, {headers: await authHeader()});
    }

    static async updateVehicleAttributeValue(attributeValueId: any, attributeValueDesc: any) {
        return http.put(`/cfadminvinadmin/api/v1/vehicle-attribute-values/${attributeValueId}?attributeValueDesc=${attributeValueDesc}`, null, {headers: await authHeader()});
    }

    static async deleteVehicleAttributeValue(attributeValueId: any) {
        return http.delete(`/cfadminvinadmin/api/v1/vehicle-attribute-values/${attributeValueId}`, {headers: await authHeader()});
    }

    static async saveFootnoteMappings(vehicleId: number, requestBody: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/vehicle-footnotes/createVehicleFootNotes?vehicleId=${vehicleId}`, requestBody, {headers: await authHeader()});
    }

    static async getAllOperationByVehicle(vehicleId: any) {
        return http.get(`/cfadminvehicleconfig/api/v1/vehicle-footnotes/getAllOperationByVehicle?vehicleId=${vehicleId}`, {headers: await authHeader()});
    }

    static async getExistVehicleOperationFootNotes(vehicleId: any) {
        return http.get(`/cfadminvehicleconfig/api/v1/vehicle-footnotes/getVehicleOperationFootNotes?vehicleId=${vehicleId}`, {headers: await authHeader()});
    }

    static async vinRefresh(request: any) {
        return http.post(`/cfadminvehicleconfig/api/v1/vehicle-configuration/decode-vin-data-nhtsa`, request, {headers: await authHeader()});
    }
}

export default VehicleConfigService;